import { useEffect, useState } from "react"
import { iAxios } from "../../../lib/utils"
import { useParams } from "react-router"
import { Users } from "./Users"
import { useDispatch } from "react-redux"
import { alertMessage } from "../../../lib/actions"
import { Integrations } from "./Integrations"
import { Spinner, TabFilter } from "../../common/Helper"


const UpdateRow = ({ item }) => {
    const [name, setName] = useState(item.name);
    const [inFligt, setInFlight] = useState(false);
    const [message,setMessage] = useState(null);

    const handleUpdate = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = {}
        for (const [key, value] of formData) {
            data[key] = value;
        } 
        setInFlight(true)
        iAxios.post('/api/v1/admin/project-update', data).then(resp => {
            console.log('resp', resp.data);
            setInFlight(false);
            setMessage(`Updated ${resp.data.data.result} issues`);
        }).catch(ex => {
            alert(ex.message);
        })
    }

    return <form className="ds-field-row" style={{ marginBottom: 0, alignItems: 'center' }} onSubmit={handleUpdate}>
        <input type="hidden" value={item.refId} name="projectId" />
        <input name="projectName" className="ds-input ds-field" value={name}
            onChange={e => setName(e.target.value)}
            placeholder={item.refId} />
        {item.name !== name && <button disabled={inFligt} className="ds-btn is-primary is-sm">Update</button>}
        {message && <div style={{ fontSize: 'var(--ds-text-xs)', color: 'var(--ds-success)' }}>{message}</div>}
    </form>
}
const Projects = () => {

    const [projects, setProjects] = useState(null);
    useEffect(() => {
        iAxios.get('/api/v1/admin/project-list').then(resp => {
            const list = resp.data.data;
            list.sort((a, b) => a.refId.localeCompare(b.refId));
            setProjects(list);
        });
    }, [1])


    return <div className="ds-panel">
        {projects == null && <Spinner />}
        <div className="ds-table-wrap">
            <table className="ds-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Id</th>
                        <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    {projects?.map((item, idx) => {
                        return <tr key={item.id || idx}>
                            <td className="ds-nums">{idx + 1}</td>
                            <td title={item.id}>{item.refId}
                                <div style={{ fontSize: 'var(--ds-text-xs)', color: 'var(--ds-ink-faint)' }}>{item.id}</div>
                            </td>
                            <td style={{ width: '50%' }}>
                                <UpdateRow item={item} />
                            </td>
                        </tr>;
                    })}
                </tbody>
            </table>
        </div>
    </div>;

}

const Preferences = (props) => {
}
const Settings = (props) => {
    const { tab = 'users' } = useParams();
    return <>
        <TabFilter mode="path" basePath="/settings"
            filters={['Users', 'Integrations']} ></TabFilter>
        <div style={{ marginTop: 'var(--ds-space-5)' }}>
            {tab === 'users' && <Users />}
            {tab === 'integrations' && <Integrations />}
            {tab === 'projects' && <Projects />}
        </div>
    </>
}

export default Settings;